import { atom } from "recoil";

 // 選択できる巡回会場リスト
export const courceVenueState = atom({
  key: "courceVenueState",
  default: null,
});